var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fpui-stars"},_vm._l((_vm.range),function(idx){return _c('i',{staticClass:"fpui-star fa fa-star",class:{active: idx <= _vm.value}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }